import { FactSheetPage } from "@modules/investor-relations/pages";
import { useLoaderData } from "@remix-run/react";

export default function FactSheet() {
  useLoaderData();

  return <FactSheetPage />;
}
